var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCtaPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142.88,
  height: 142.86
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-888.84 -5030.85)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 6",
  cx: 71.44,
  cy: 71.43,
  rx: 71.44,
  ry: 71.43,
  transform: "translate(888.84 5030.85)",
  fill: "#252829"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape 5",
  d: "M950.965 5075.461v54.211L984.847 5102Z",
  fill: "#fff"
}))));

export default SvgCtaPlay;